/* eslint-disable */
import { auth } from '@/plugins/auth/firebase.js'

export const marketplace = {
  namespaced: true,
  state: {
  },

  mutations: {

  },

  actions: {
    metodo1({rootState, mutations , state}, payload){
      // console.log(payload)
      let userId = rootState.users.user.adminUid  ? rootState.users.user.adminUid : rootState.users.user.uid
      let shopId = rootState.shops.currentItem.id
      let ref = firebase.database().ref().child(`users/${userId}/shops/${shopId}`)
      // console.log(userId, shopId)
      ref.once('value',function(snapshot){
        // console.log(snapshot.val().active)
        if(snapshot.val().active){

          ref.update({'active':false}).then(function () {

          })
        }else{
          ref.update({'active':true}).then(function () {

          })
        }
      })
    },
    async createItem ({ commit, state, rootState }, payload) {
      commit('SET_LOADING', true)
      let userId = ''
      if(rootState.users.user.adminUid){
        userId = rootState.users.user.adminUid
      }else{
        userId = rootState.users.user.uid
      }
      // console.log(userId, payload)
      const key = payload.id ? payload.id : firebase.database().ref().child(`users/${userId}/inventory`).push().key
      const itemData = {
        ...payload,
        id: key,
        created: firebase.database.ServerValue.TIMESTAMP,
      }
      // console.log(itemData)
      const updates = {}
      updates[`users/${userId}/inventory/${key}`] = itemData
      await firebase.database().ref().update(updates).then(function () {
        // created!
        commit('SET_LOADING', false)
      })
    },
    metodo2({
        commit,
        state,
        rootState
      }, params) {
      console.info(params)
      // // obtengo el id del usuario|administrador
      // let userId = rootState.users.user.adminUid ? rootState.users.user.adminUid : rootState.users.user.uid
      // // console.info(userId)
      // // obtengo el shop del id
      // let shopId = rootState.shops.currentItem.id
      // // creo la referencia en firebase
      // let ref = firebase.database().ref().child(`users/${userId}/shops/${shopId}`)
      // ref.once('value', function (snapshot) {
      //   ref.update({
      //     excluded: {
      //       'product_id':{
      //         id: '1',
      //         image: 'placehold.it/500',
      //         name: 'Prueba Frederick'
      //       }
      //     }
      //   })
      // })
    }
  },
}
